import React from 'react';

import CodeEditorContext from './CodeEditorContext';

/**
 * Format the code using Prettier!
 * NOTE: This method is a backup. The main method exists inside
 * CodeEditorContext, we add an event listener direct to the
 * codeMirrorInstance.
 *
 * This method is useful if the user has, eg, one of the tabs
 * focused and they hit the shortcut. it won't work if they don't
 * have a focusable element focused, but it's better than nothing!
 */
function useSaveShortcut() {
  const { formatCodeWithOffset } =
    React.useContext(CodeEditorContext);

  const handleKeydown = React.useCallback(
    (ev: React.KeyboardEvent) => {
      const macShortcutPressed = ev.metaKey && ev.key === 's';
      const windowsShortcutPressed = ev.ctrlKey && ev.key === 's';

      if (macShortcutPressed || windowsShortcutPressed) {
        ev.preventDefault();
        ev.stopPropagation();
        formatCodeWithOffset();
      }
    },
    [formatCodeWithOffset]
  );

  return handleKeydown;
}

export default useSaveShortcut;
